import React from "react";
import { Button } from "antd";
import { CheckCircleFilled, MailOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./auth.css";

const RegistrationSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="ciq-auth">
      <aside className="ciq-auth__brand">
        <div className="ciq-auth__brand-bg" />
        <div className="ciq-auth__brand-inner">
          <a className="ciq-brand" href="https://coreiqpro.com">
            <img src={`${process.env.PUBLIC_URL}/logo-icon.png`} alt="CoreIQPro" />
            <span className="ciq-brand__txt">
              Core<span className="o">IQ</span>Pro
            </span>
          </a>
          <h1 className="ciq-auth__headline">You are almost there.</h1>
          <p className="ciq-auth__sub">
            Your account is created. One quick email step and you are ready to start learning.
          </p>
          <ul className="ciq-auth__points">
            <li>
              <i className="fas fa-check" /> Free courses to get you started
            </li>
            <li>
              <i className="fas fa-check" /> Track progress and earn certificates
            </li>
            <li>
              <i className="fas fa-check" /> Learn at your own pace
            </li>
          </ul>
        </div>
      </aside>

      <main className="ciq-auth__panel">
        <div className="ciq-auth__card">
          <div className="ciq-auth__card-head">
            <div>
              <h2>Registration successful</h2>
              <p className="ciq-auth__muted">Your account has been created.</p>
            </div>
          </div>

          <div className="ciq-auth__msg success">
            <div className="ciq-auth__msg-title">
              <CheckCircleFilled /> Check your email
            </div>
            We have sent a confirmation link to your registered email address.
          </div>

          <div className="ciq-auth__steps">
            <div className="ciq-auth__step">
              <span className="n">1</span> Check your inbox for the confirmation email
            </div>
            <div className="ciq-auth__step">
              <span className="n">2</span> Click the confirmation link to verify your email
            </div>
            <div className="ciq-auth__step">
              <span className="n">3</span> Set your password to complete setup
            </div>
          </div>

          <p className="ciq-auth__tip">
            <MailOutlined /> Tip: check your spam folder if you do not see it. The link is valid for 24 hours.
          </p>

          <Button type="primary" block onClick={() => navigate("/login")}>
            Go to Sign In
          </Button>
        </div>
      </main>
    </div>
  );
};

export default RegistrationSuccess;
